import { useAdminDashboardStore } from '@/modules/admin/stores/dashboard.store'
import { useLeadsStore } from '@/modules/admin/stores/leads.store'
import { useSalesStore } from '@/modules/admin/stores/sales.store'

export const CRM_EVENTS = {
  DATA_CHANGED: 'crm:data-changed',
}

export function notifyDataChanged(detail = {}) {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(CRM_EVENTS.DATA_CHANGED, { detail }))
  }
}

export function syncAllAdminData(detail = {}) {
  try {
    // Refresh leads list and metadata
    void useLeadsStore.getState().fetchLeads?.()

    // Refresh admin dashboard metrics
    void useAdminDashboardStore.getState().fetchDashboard?.()

    // Refresh sales list and metrics
    void useSalesStore.getState().fetchSales?.()

    // Dispatch global event for local component listeners (Quotations table, etc.)
    notifyDataChanged(detail)
  } catch (error) {
    console.error('Error syncing admin data:', error)
  }
}
